import React from 'react';
import { StyleSheet, View } from 'react-native';
import TouchableBounce from 'utils/packages/TouchableBounce';
import Text from 'design-system/Text';
import Amount from 'design-system/Amount';
import { CardView, rem } from 'design-system';
import { formatPlural } from 'utils';
import GroupAvatar from './GroupAvatar';
const GroupCard = ({ group, onPress, showAmount }) => (<TouchableBounce key={String(group?.id)} onPress={onPress}>
    <CardView noMarginTop>
      <View style={styles.groupRow}>
        <GroupAvatar name={group.name} url={group.iconUrl}/>
        <View style={styles.groupRowLeftContent}>
          <Text Text-16 OffBlack numberOfLines={1}>
            {group.name}
          </Text>

          <Text TextThin-14 Secondary>
            {group.userIds.length}{' '}
            {formatPlural('member', 'members', group.userIds?.length || 0)}
          </Text>
        </View>
        {!!showAmount && (<View style={styles.groupRowRightContentText}>
            <Amount Numbers-16 right value={{
            value: Math.abs(group.netBalance.balance),
            currency: group.netBalance.currency,
        }}/>
            <Text TextThin-14 Secondary right>
              {group.netBalance.balance < 0 ? 'you owe' : 'owed'}
            </Text>
          </View>)}
      </View>
    </CardView>
  </TouchableBounce>);
const styles = StyleSheet.create({
    groupRow: {
        padding: rem(16),
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    groupRowLeftContent: {
        flex: 1,
        marginLeft: rem(16),
        justifyContent: 'center',
    },
    groupRowRightContentText: {
        marginLeft: rem(16),
        justifyContent: 'flex-end',
        textAlign: 'right',
    },
});
export default GroupCard;
